export enum CloudFunction {
    cron_scheduled_procedure = 'cron_scheduled_procedure',
    cron_purchasing_ordered_and_received_notifications = 'cron_purchasing_ordered_and_received_notifications',
    cron_purchasing_expected_arrival_notifications = 'cron_purchasing_expected_arrival_notifications',
    cron_purchasing_unreadied_items_notifications = 'cron_purchasing_unreadied_items_notifications',
    cron_shipping_manager_skid_creation_notifications = 'cron_shipping_manager_skid_creation_notifications',
    cron_update_roto_machine_approximate_daily_cycle_count = 'cron_update_roto_machine_approximate_daily_cycle_count',
    cron_add_recent_logins = 'cron_add_recent_logins',
    cron_find_new_user_devices = 'cron_find_new_user_devices',
    cron_load_all_gmail_users = 'cron_load_all_gmail_users',
    cron_metals_project_tasks_completed_notification = 'cron_metals_project_tasks_completed_notification',
    cron_maintenance_task_review_notification = 'cron_maintenance_task_review_notification',
    cron_complaint_log_scheduled_products_notification = 'cron_complaint_log_scheduled_products_notification',

    cron_release_scheduled_ordered_products = 'cron_release_scheduled_ordered_products',

    cron_ups_shipment_tracking_updates = 'cron_ups_shipment_tracking_updates',
    cron_c3_inventory_threshold_report = 'cron_c3_inventory_threshold_report',
    cron_plastics_daily_production_rollup = 'cron_plastics_daily_production_rollup',
    cron_mold_checkup_daily_summary = 'cron_mold_checkup_daily_summary',
}
